var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies, Layout, Auth } from "~/core/decorator";
import NumberRange from "~/components/common/number-range.vue";
import { PageService } from "~/utils/page.service";
import ManualDistrubute from "~/components/case-import/manual-distrubute.vue";
import { State } from "vuex-class";
import { CaseInfoService } from "../../services/domain-service/case-info.service";
import { MENU_CHANNEL } from "~/config/enum.config";
import GetLabelName from "~/components/labeling-strategy/get-label-name.vue";
var UndistributedCase = /** @class */ (function (_super) {
    __extends(UndistributedCase, _super);
    function UndistributedCase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.importModel = {
            principalId: "",
            batchNumber: "",
            mobileNo: "",
            personalName: "",
            amountRange: { min: "", max: "" },
            caseNumber: '',
            principalName: '',
            partnerName: '',
            bankName: '',
            businessAddress: '',
            boardAddress: '',
            carNo: '',
            idCard: '',
            loanDate: [],
            dataFromSource: '',
            overdueDays: {
                max: "",
                min: ""
            },
            compensationMoney: {
                max: "",
                min: ""
            }
        };
        _this.dialog = {
            manual: false
        };
        // 表单验证规则
        _this.undistributedRule = {
            mobileNo: [
                {
                    validator: _this.$validator.phoneNumber,
                    trigger: "blur"
                }
            ]
        };
        _this.importDataSet = [];
        _this.selectionList = [];
        _this.caseDetail = {};
        return _this;
    }
    /**
     * 获取待分配案件
     */
    UndistributedCase.prototype.refreshData = function () {
        var _this = this;
        this.CaseInfoService.getAllDistributeCaseInfos(this.importModel, this.pageService).subscribe(function (data) {
            _this.importDataSet = data;
            _this.selectionList = [];
        });
    };
    UndistributedCase.prototype.mounted = function () {
        this.refreshData();
    };
    /**
     * 手动分案
     */
    UndistributedCase.prototype.manualDistruibute = function () {
        // if (this.selectionList.length === 0) {
        // this.$message("请选择要分配的案件");
        this.dialog.manual = true;
        // } else {
        //     this.dialog.manual = true;
        // }
    };
    /**
     * 重置numberRange
     */
    UndistributedCase.prototype.follFeedback = function () {
        this.importModel.amountRange = { min: "", max: "" };
        this.importModel.dayRange = { min: "", max: "" };
        this.importModel.rateRange = { min: "", max: "" };
        this.importModel.caseMoney = { min: "", max: "" };
        this.importModel.compensationMoney = { min: "", max: "" };
        this.importModel.overdueDays = { min: "", max: "" };
    };
    /**
     * 进入查看执行页
     */
    UndistributedCase.prototype.openExecutionPage = function (row) {
        this.$router.openCaseDetail(row.id, {
            menuChannel: MENU_CHANNEL.Case_await,
            hiddenCaseList: true,
            hiddenAction: true,
            hiddenCollectionStatus: true
        });
    };
    /**
     * 导出案件
     */
    UndistributedCase.prototype.exportCaseInfo = function () {
        var _this = this;
        var ids = this.selectionList.map(function (v) { return v.id; });
        var request = __assign(__assign({}, this.importModel), { caseIds: ids });
        this.CaseInfoService
            .distributeCaseInfosExport(request)
            .subscribe(function (data) { return _this.$common.downloadFile(data.url); });
    };
    /**
     * 导出催记
     */
    UndistributedCase.prototype.exportFollowup = function () {
        var _this = this;
        var ids = this.selectionList.map(function (v) { return v.id; });
        var request = __assign(__assign({}, this.importModel), { caseIds: ids });
        this.CaseInfoService
            .distributeCaseInfosExportFollow(request)
            .subscribe(function (data) { return _this.$common.downloadFile(data.url); });
    };
    __decorate([
        State
    ], UndistributedCase.prototype, "principalList", void 0);
    __decorate([
        Dependencies(PageService)
    ], UndistributedCase.prototype, "pageService", void 0);
    __decorate([
        Dependencies(CaseInfoService)
    ], UndistributedCase.prototype, "CaseInfoService", void 0);
    UndistributedCase = __decorate([
        Auth(101),
        Layout("workspace"),
        Component({
            components: {
                ManualDistrubute: ManualDistrubute,
                GetLabelName: GetLabelName,
                NumberRange: NumberRange
            }
        })
    ], UndistributedCase);
    return UndistributedCase;
}(Vue));
export default UndistributedCase;
